module.exports = __webpack_public_path__ + "static/media/banknote.94b8021c.svg";